function toOptionKey(option: unknown): unknown {
  if (typeof option === 'object' && option !== null && 'value' in option) {
    return option.value;
  }
  return option;
}

export function isSameComboboxOption(itemValue: unknown, selectedValue: unknown): boolean {
  return Object.is(toOptionKey(itemValue), toOptionKey(selectedValue));
}
